import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import siteConfig from '../config';

const About = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-gray-950 via-black to-gray-950 relative overflow-hidden">
      {/* Background Decorations */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-yellow-500/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-yellow-600/5 rounded-full blur-3xl"></div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="max-w-4xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-12">
            <h2 className="text-4xl sm:text-5xl font-bold text-white mb-4">
              {siteConfig.about.title}
            </h2>
            <div className="h-1 w-24 bg-gradient-to-r from-yellow-400 to-yellow-600 mx-auto mb-6"></div>
          </div>

          {/* Content */}
          <div className="space-y-6">
            {siteConfig.about.description.map((paragraph, index) => (
              <div 
                key={index}
                className="bg-white/5 backdrop-blur-sm border border-yellow-500/20 rounded-2xl p-8 hover:bg-white/10 transition-all duration-300 transform hover:scale-[1.02]"
              >
                <div className="flex items-start space-x-4">
                  <div className="flex-shrink-0 mt-1">
                    <div className="w-8 h-8 bg-gradient-to-br from-yellow-400 to-yellow-600 rounded-full flex items-center justify-center">
                      <CheckCircle2 className="w-5 h-5 text-black" />
                    </div>
                  </div>
                  <p className="text-gray-300 text-lg leading-relaxed">
                    {paragraph}
                  </p>
                </div>
              </div>
            ))}
          </div>

          {/* Mission Statement Highlight */}
          <div className="mt-12 bg-gradient-to-r from-yellow-500/10 via-yellow-600/10 to-yellow-500/10 border-l-4 border-yellow-500 rounded-r-2xl p-8">
            <p className="text-2xl font-semibold text-white text-center">
              "Deliver precision, transparency, and performance for every luxury vehicle we service."
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
